module.exports = __webpack_public_path__ + "static/img/bg_reward_item_green.0b711e5e.svg";